export default __webpack_public_path__ + "static/media/apple-store-badge.9c41aa88.png";